/** 상세사유 최소 길이 — 핸드오프 모달 `okValidate.minLength`. */
export const REASON_DETAIL_MIN_LENGTH = 5

/** 서버 응답에 파일명이 없을 때만 쓰는 대체 이름(BE 는 `센터도착수령내역조회[_상세]_<시각>.zip` 을 준다). */
export const EXCEL_FILE_NAME_PREFIX = '센터도착수령내역조회'

export const MESSAGES = {
  searchFailed: '조회에 실패했습니다.',
  excelNoRows: '다운로드할 조회 결과가 없습니다.',
  // 컨덕터 뷰의 엑셀 사유 모달은 [확인] 을 잠그지 않는다 — 배선이 막고 모달을 유지한다(throw).
  reasonInvalid: `사유코드를 고르고 상세사유를 ${REASON_DETAIL_MIN_LENGTH}글자 이상 입력해주세요.`,
} as const
